import { Link } from 'react-router-dom';
import '../accounting-reports.css';

const REPORTS = [
  {
    path: '/reports/accounting/general-ledger',
    title: 'General Ledger',
    description: 'Debit/credit lines by GL category for an exported payroll run, with mapping and balance status.',
  },
  {
    path: '/reports/accounting/payroll-journal',
    title: 'Payroll Journal',
    description: 'Per-employee pay, tax, deduction, and cost detail for an approved payroll run.',
  },
  {
    path: '/reports/accounting/payroll-liabilities',
    title: 'Payroll Liabilities',
    description: 'Calculated tax liabilities and their deposit status, by form and period.',
  },
  {
    path: '/reports/accounting/funding-transactions',
    title: 'Funding & Bank Transactions',
    description: 'Payment batches and the individual transactions Escochex has confirmed for each payroll run.',
  },
] as const;

/** EPN-77 — Accounting Reports hub. Four fixed MVP reports, each reusing an existing, already-working
 * gateway (Accounting/Reports/PayrollTaxes/Payments) — no new backend was introduced for this ticket. */
export function AccountingReportsHubPage() {
  return (
    <section className="card card--wide" aria-labelledby="accounting-reports-heading">
      <div className="section-header">
        <h2 id="accounting-reports-heading">Accounting Reports</h2>
      </div>
      <p className="muted">
        Payroll-accounting reports derived from finalized payroll and accounting records. These reports never
        recalculate payroll — they group, summarize, and reconcile data EPN has already computed elsewhere.
      </p>
      <div className="report-hub-grid">
        {REPORTS.map((report) => (
          <Link key={report.path} to={report.path} className="report-card">
            <h3>{report.title}</h3>
            <p>{report.description}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
